import { useMutation } from '@tanstack/react-query';
import { ArrowRight, CheckCircle2, KeyRound, LockKeyhole, Mail } from 'lucide-react';
import { FormEvent, useState } from 'react';
import { api } from '../lib/api';

export function Auth() {
  const [email, setEmail] = useState('');
  const [pin, setPin] = useState('');
  const [trusted, setTrusted] = useState(true);
  const login = useMutation({
    mutationFn: () => api.login({ email, pin, trusted }),
    onSuccess: () => location.assign('/'),
  });
  const submit = (event: FormEvent) => { event.preventDefault(); login.mutate(); };
  return <main className="auth-page">
    <section className="auth-atmosphere" aria-hidden="true"><div/><div/><div/></section>
    <section className="auth-card panel">
      <div className="auth-brand"><span><LockKeyhole/></span><div><strong>Babel Foundry</strong><small>Private project workstation</small></div></div>
      <span className="mono eyebrow">AUTHORIZED ENTRY</span>
      <h1>Enter the Foundry.</h1>
      <p>Your email identifies the member record. Your PIN unlocks it.</p>
      <form onSubmit={submit}>
        <label><span><Mail size={15}/> Email</span><input type="email" autoComplete="username" required value={email} onChange={(event)=>setEmail(event.target.value)} placeholder="you@example.com"/></label>
        <label><span><KeyRound size={15}/> PIN</span><input type="password" inputMode="numeric" pattern="[0-9]{6,12}" minLength={6} maxLength={12} autoComplete="current-password" required value={pin} onChange={(event)=>setPin(event.target.value.replace(/\D/g,'').slice(0,12))} placeholder="6–12 digits"/></label>
        <label className="trust-browser"><input type="checkbox" checked={trusted} onChange={(event)=>setTrusted(event.target.checked)}/><span><CheckCircle2 size={16}/><strong>Trust this browser</strong><small>Stay signed in for 30 days. Leave off on shared devices.</small></span></label>
        <button className="primary-button auth-submit" disabled={login.isPending}>{login.isPending?'Opening…':'Open Foundry'}<ArrowRight size={17}/></button>
        {login.error&&<p className="form-error">{login.error.message}</p>}
      </form>
      <a className="registration-link" href="/register"><span>Not registered?</span> Set up email.<ArrowRight size={14}/></a>
      <small className="auth-footnote">Five incorrect PIN attempts pause login for 15 minutes.</small>
    </section>
  </main>;
}
